import { useQuery } from '@apollo/client'
import { UseFetchContractHistoryDataDocument } from 'generated/resources/graphql'

import useFetchAdditionalCompensations from './useFetchAdditionalCompensations'
import useFetchCustomFieldValues from './useFetchCustomFieldValues'

const useFetchContractHistoryData = (contractVersionIds: string[]) => {
  const newAdditionalCompensationsQueryResult = useQuery(UseFetchContractHistoryDataDocument, {
    variables: {
      contractVersionIds,
    },
  })
  const additionalCompensations = useFetchAdditionalCompensations(contractVersionIds)
  const customFieldValues = useFetchCustomFieldValues(contractVersionIds)

  return {
    additionalCompensations,
    customFieldValues,
    newAdditionalCompensations:
      newAdditionalCompensationsQueryResult?.data?.contracts.additionalCompensationsConnection
        .nodes ?? [],
  }
}

export default useFetchContractHistoryData
